import { render, staticRenderFns } from "./BrokerStatementsAccounting.vue?vue&type=template&id=d9c5c5c6&scoped=true&"
import script from "./BrokerStatementsAccounting.vue?vue&type=script&lang=js&"
export * from "./BrokerStatementsAccounting.vue?vue&type=script&lang=js&"
import style0 from "./BrokerStatementsAccounting.vue?vue&type=style&index=0&id=d9c5c5c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9c5c5c6",
  null
  
)

export default component.exports